import styled from 'styled-components';
import { useNavigate } from "react-router-dom";
import { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Wrapper = styled.div`
  min-height: 100vh;
  width: 100vw;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Card = styled.form`
  background: #fff;
  width: 400px;
  padding: 2.5rem 2.2rem;
  border-radius: 12px;
  box-shadow: 0 2px 18px rgba(35,62,88,0.07);
  display: flex;
  flex-direction: column;
  border: 1px solid #e9e9e9;
`;

const Title = styled.h2`
  color: #20294d;
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 8px;
  margin-top: 0;
  font-family: 'Inter', Arial, sans-serif;
`;

const Description = styled.div`
  color: #7a7e86;
  font-size: 1.01rem;
  margin-bottom: 1.55rem;
  font-weight: 400;
  font-family: 'Inter', Arial, sans-serif;
`;

const Label = styled.label`
  color: #20294d;
  font-size: 0.97rem;
  font-weight: 700;
  margin-bottom: 0.32rem;
  font-family: 'Inter', Arial, sans-serif;
`;

const Input = styled.input`
  border: 1px solid #d1d5db;
  border-radius: 8px;
  height: 42px;
  font-size: 1.03rem;
  padding: 0 1rem;
  margin-bottom: 1.1rem;
  font-family: 'Inter', Arial, sans-serif;
  background: #fff;
  transition: border-color 0.18s linear;

  &:focus {
    border-color: #3772FF;
    outline: none;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
`;

const Button = styled.button`
  background: ${props => props.cancel ? '#ccc' : '#3772FF'};
  color: ${props => props.cancel ? '#333' : '#fff'};
  border: none;
  height: 44px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1.01rem;
  cursor: pointer;
  width: 48%;
  transition: background 0.2s;

  &:hover {
    background: ${props => props.cancel ? '#bbb' : '#2462dc'};
  }

  &:disabled {
    background: #eee;
    color: #999;
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.p`
  color: red;
  font-size: 0.9rem;
  margin: 0 0 0.8rem 0;
`;

export default function ResetPasswordSimple({ onCancel }) {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const userData = JSON.parse(localStorage.getItem('user'))
  
  const validate = () => {
    if (!password) return "Password is required";
    if (password.length < 6) return "Password must be at least 6 characters";
    if (password !== confirmPassword) return "Passwords do not match";
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validate();
    if (validationError) {
      setError(validationError);
      return;
    }
    setError('');
    setLoading(true);

    try {
      const userId = JSON.parse(localStorage.getItem('user')).id
      const res = await axios.post(`${BACKEND_URL}/auth/reset-password`, { userId  ,password });
      if(res.status == 200){
        alert('Password reset successful. Login to continue');
      localStorage.clear()
      navigate('/');}
    } catch (err) {
      setError('Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <Card onSubmit={handleSubmit}>
        <Title>Reset Password</Title>
        <Description>Please enter your new password below and confirm to reset your password.</Description>

        {error && <ErrorMessage>{error}</ErrorMessage>}

        <Label htmlFor="password">New Password</Label>
        <Input
          id="password"
          type="password"
          placeholder="Enter new password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          disabled={loading}
        />

        <Label htmlFor="confirmPassword">Confirm Password</Label>
        <Input
          id="confirmPassword"
          type="password"
          placeholder="Confirm new password"
          value={confirmPassword}
          onChange={e => setConfirmPassword(e.target.value)}
          disabled={loading}
        />

        <ButtonGroup>
          <Button type="button" cancel onClick={onCancel || (() => navigate(-1))} disabled={loading}>
            Cancel
          </Button>
          <Button type="submit" disabled={loading}>
            {loading ? 'Submitting...' : 'Submit'}
          </Button>
        </ButtonGroup>
      </Card>
    </Wrapper>
  );
}
